import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../../../components/spinner/Spinner';
import { getUrlParams } from '../../../../utils/shared/urlUtils';
import ProgressGrid from '../ProgressGrid';
import { PROGRESS_TABLE_SORTABLE_COLUMNS } from '../../../../constants/shared/PMConstants';

const ProgressTable = ({
    pmPeriod,
    areResultsUpdating,
    ProbeDetailsPageContainer,
    colSpans,
    rowSpans,
    location,
}) => {
    const { resultId } = getUrlParams(location);
    return areResultsUpdating ? (
        <Spinner />
    ) : (
        <>
            {resultId && <ProbeDetailsPageContainer resultId={resultId} />}
            <ProgressGrid
                gridKey={pmPeriod}
                colSpans={colSpans}
                rows={rowSpans}
                period={pmPeriod}
                sortableColumns={PROGRESS_TABLE_SORTABLE_COLUMNS}
            />
        </>
    );
};

ProgressTable.defaultProps = {
    pmPeriod: null,
    areResultsUpdating: false,
};

ProgressTable.propTypes = {
    pmPeriod: PropTypes.string,
    areResultsUpdating: PropTypes.bool,
    ProbeDetailsPageContainer: PropTypes.any.isRequired,
    colSpans: PropTypes.array.isRequired,
    rowSpans: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
};

export default ProgressTable;
